<template>
  <div id="app" ref="body" @scroll="scrollTop()">
    <top :navN="navN" :Toptype="Toptype"></top>
    <banner :list="list" style="margin-top:.98rem"></banner>
    <idata :countToB="countToB"></idata>
    <selectionArea></selectionArea>
    <gift></gift>
    <giftO></giftO>
    <giftT></giftT>
    <welfare></welfare>
    <welfareO></welfareO>
    <welfareT></welfareT>
    <welfareE></welfareE>
    <welfareF></welfareF>
    <welfareG></welfareG>
    <welfareH></welfareH>
    <companyProfile></companyProfile>
    <qualifications></qualifications>
    <team></team>
    <news></news>
    <cooperative></cooperative>
    <bottom></bottom>
    <right @top="$refs.body.scrollTop = 0"></right>
    <TopN v-show="isTop" @top="$refs.body.scrollTop = 0"></TopN>
  </div>
</template>

<script>
import top from '../../components/Top'
import banner from '../../components/Banner'
import selectionArea from './components/selectionArea'
import idata from './components/idata'
import gift from './components/gift'
import giftO from './components/giftO'
import giftT from './components/giftT'
import welfare from './components/welfare'
import welfareO from './components/welfareO'
import welfareT from './components/welfareT'
import welfareE from './components/welfareE'
import welfareF from './components/welfareF'
import welfareG from './components/welfareG'
import welfareH from './components/welfareH'
import companyProfile from './components/companyProfile'
import qualifications from './components/qualifications'
import team from './components/team'
import cooperative from './components/cooperative'
import news from './components/news'
import bottom from '../../components/Bottom'
import right from '../../components/right'
import TopN from '../../components/TopN'
export default {
  name: 'index',
  components: {
    top,
    banner,
    selectionArea,
    idata,
    gift,
    giftO,
    giftT,
    welfare,
    welfareO,
    welfareT,
    welfareE,
    welfareF,
    welfareG,
    welfareH,
    companyProfile,
    qualifications,
    team,
    news,
    cooperative,
    bottom,
    right,
    TopN
  },
  data () {
    return {
      navN: 0,
      page: 1,
      Toptype: 0,
      list: [],
      countToB: false,
      isTop: false      
    }
  },
  mounted () {
    this.getIndex()
    this.init()
    this.postList()
    this.getBanner()
    if (!this.countToB) {
      this.countToB = true
    }
  },
  methods: {
    getIndex () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getNews', {
      }).then(
        function (res) {
          res = res.data.data.introduce
          if (res.topTitle) {
            document.title = res.topTitle
            
            var metas = document.getElementsByTagName("meta")
            metas[0].name ="Description" 
            metas[0].content=res.desc

            var metas = document.getElementsByTagName("meta")
            metas[1].name ="Keywords"
            metas[1].content=res.slaveTitle
          }
        }
      ).catch(error => console.log(error))
    },
    init () {
      this.$axios.get(process.env.API_HOSTT + '/os/init').then(
        function (res) {
          // console.log(res.data)
        }
      ).catch(error => console.log(error))
    },
    scrollTop () {
      let scrollTop = this.$refs.body.scrollTop// 滚动条的高
      if (scrollTop > 500) {
        this.Toptype = 1
      } else {
        this.Toptype = 0
      }
      if (scrollTop > 1200) {
        this.isTop = true
      } else if (scrollTop == 0) {
        this.isTop = false
      }
    },
    postList () {
      // this.$axios.post(process.env.API_HOST + '/api/getComment',
      //   {
      //     comment_type: 1
      //   }).then(
      //   function (res) {
      //     console.log(res)
      //   }
      // ).catch(error => console.log(error))
    },
    getBanner () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getBanner', {
        params: {
          navId: 0
        }
      }).then(
        function (res) {
          res = res.data.data
          that.list = res
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus">
.titleD
  display flex
  justify-content center
  .titleDT
    font-size .65rem
    color var(--indexColor)
    line-height .65rem
    font-weight bold
    margin-right .1rem
  .title
    font-size .30rem
    color var(--hei)
    font-weight 700
    height .52rem
    line-height .52rem
    text-align center
  .titlex
    font-size .16rem
    color #999999
    line-height .16rem
    text-align center
    margin-bottom 0
    text-align left
.xian
  width 2.98rem
  height .02rem
  background var(--indexColor)
  position relative
  margin auto
  margin-top .19rem
  margin-bottom .43rem
.xian::after,.xian::before
  content ''
  width .06rem
  height .06rem
  position absolute
  top -.025rem
  background var(--indexColor)
  border-radius 60%
.xian::after
  left 0
.xian::before
  right 0
</style>
<style lang="stylus" scoped>
#app
  width 100%
  height 100%
  overflow auto
  .advertisement
    width 100%
    font-size .4rem
    text-align center
    color #fff
    position relative
    img
      width 100%
      height 100%
      object-fit cover
    div
      position absolute
      top 50%
      left 50%
      transform: translate(-50%,-50%);
      .titlex,.title
        color #fff
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue